<div class="icon-action-group"
     [attr.data-testid]="testId()">
  @for (action of actions(); track $index) {
    @if (action.capture) {
      <app-photo-capture-button [ariaLabel]="action.ariaLabel"
                                [count]="action.count ?? 0"
                                [disabled]="!!action.disabled"
                                [source]="action.capture"
                                [inputId]="action.inputId ?? resolveTestId(action, $index)"
                                (filesSelected)="action.filesSelected?.($event)"
                                [testId]="resolveTestId(action, $index)" />
    } @else if (action.action) {
      <button type="button"
              class="icon-action"
              [disabled]="!!action.disabled"
              [attr.aria-label]="action.ariaLabel"
              (click)="handleClick(action)"
              [attr.data-testid]="resolveTestId(action, $index)">
        <ng-container [ngTemplateOutlet]="glyph"
                      [ngTemplateOutletContext]="{ $implicit: action }" />
      </button>
    } @else {
      <span class="icon-action"
            [attr.aria-label]="action.ariaLabel"
            [attr.data-testid]="resolveTestId(action, $index)">
        <ng-container [ngTemplateOutlet]="glyph"
                      [ngTemplateOutletContext]="{ $implicit: action }" />
      </span>
    }
  }
</div>

<ng-template #glyph
             let-action>
  <span class="icon-action-glyph">
    <i [class]="action.icon"
       aria-hidden="true"></i>
    @if (action.count > 0) {
      <p-badge [value]="action.count.toString()"
               severity="danger"
               badgeSize="small"
               styleClass="bqa-icon-badge" />
    }
  </span>
</ng-template>
